/* eslint-disable no-constant-condition */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef, useMemo } from "react";

import { Table, Button, Row, Col, Input, Space, Dropdown } from "antd";
import Highlighter from "react-highlight-words";
import { DownOutlined, EditOutlined, SearchOutlined } from "@ant-design/icons";
import { AdministrationFaltantesAddForm } from "./AdministrationFaltantesAddForm";

import "react-datepicker/dist/react-datepicker.css";
import "../theme/AdministracionCatalogo.css";
import "../theme/Pagination.css";
// import axiosInstance from "../Api/AxiosInstance/AxiosInstance";
import EvidenciesView from "./Modals/Faltantes/EvidenciasView";
import createAxiosInstanceNew from "../Api/AxiosInstance/AxiosInstance";
import UpdateStatusFaltanteModal from "./Modals/Faltantes/updateFaltanteStatus";
import formatCurrency from "../utils/FormatCurrency";
import WeekSelect from "./Forms/Dates/WeekSelect";
import { UploadCsvStepsProvider } from "../context/Faltantes/UploadCsvContext";
import Tag from "../utils/StatusTag";
import { useNavigate } from "react-router-dom";
import UsePermissions from "../hooks/usePermissions";
import { UseAdmin } from "../hooks";

export const TableAdministracionFaltantes = () => {
  const navigate = useNavigate();
  const { brandfiMarcaId, branchFiSucursalId } = UseAdmin();
  const { hasAllBrandsViewChild1, hasAllPermissionsChild1, hasAllShopsViewChild1, hasPermission } =
    UsePermissions();

  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalKey, setModalKey] = useState(0);
  const [loading, setLoading] = useState(false);

  const [refetchTrigger, setRefetchTrigger] = useState(false);

  const [shopsData, setShopsData] = useState([]);

  const [faltante, setFaltante] = useState({
    data: {
      faltanteCode: "",
      evidencias: [],
      analistComment: "",
    },
    open: false,
  });

  const [updateStatusModal, setUpdateStatusModal] = useState({
    faltanteCode: "",
    currentStatus: 0,
    updateComment: "",
    open: false,
  });

  const triggerRefetch = () => {
    setRefetchTrigger((prev) => !prev);
  };

  const hasMissingUpload = useMemo(() => {
    return hasPermission("CHILD1", "missing.uploat");
  }, [hasPermission]);

  const hasMissingUpdateStatus = useMemo(() => {
    return hasPermission("CHILD1", "missing.update.status");
  }, [hasPermission]);

  const hasSendersConfigPermission = useMemo(() => {
    return hasPermission("CHILD1", "senders.config");
  }, [hasPermission]);

  const handleOpenModalEvidencias = (item) => {
    setFaltante({
      data: {
        ...item,
        analistComment: item.FCSEGUIMIENTOANALISTA,
        evidencias: item?.evidencias || [],
        faltanteCode: item?.FCCODIGOFALTANTE,
      },
      open: true,
    });
  };

  const handleOpenUpdateStatusModal = (item) => {
    setUpdateStatusModal({
      faltanteCode: item.FCCODIGOFALTANTE,
      currentStatus: item.FIESTATUSID,
      updateComment: item.FCSEGUIMIENTOANALISTA,
      open: true,
    });
  };

  const handleAdd = () => {
    setSelectedItem(null);
    setShowModal(true);
    setModalKey(modalKey + 1); // Cambiar el valor de modalKey cada vez que se abre el modal
  };

  useEffect(() => {
    if (brandfiMarcaId || refetchTrigger || branchFiSucursalId) {
      const fetchFaltanteData = async () => {
        try {
          setLoading(true);
          const axiosInstance = await createAxiosInstanceNew();

          const res = await axiosInstance.get(`faltante`, {
            params: {
              FIPAISID: 1,
              ...(!hasAllPermissionsChild1 &&
                !hasAllBrandsViewChild1 && {
                  FIMARCAID: brandfiMarcaId,
                }),
              ...(!hasAllShopsViewChild1 &&
                !hasAllPermissionsChild1 &&
                !hasAllBrandsViewChild1 && {
                  FISUCURSALID: branchFiSucursalId,
                }),
            },
          });

          if (res.status === 200) {
            const { body } = res.data;
            setShopsData(body);
            if (faltante.open === true) {
              for (const sucursal of body) {
                for (const item of sucursal.faltantes) {
                  if (item.FCCODIGOFALTANTE === faltante.data.faltanteCode) {
                    setFaltante({
                      data: {
                        ...item,
                        analistComment: item.FCSEGUIMIENTOANALISTA,
                        evidencias: item?.evidencias || [],
                        faltanteCode: item?.FCCODIGOFALTANTE,
                      },
                      open: true,
                    });
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error("Error al obtener los faltantes", error);
        } finally {
          setLoading(false);
        }
      };

      fetchFaltanteData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    refetchTrigger,
    createAxiosInstanceNew,
    hasAllBrandsViewChild1,
    hasAllPermissionsChild1,
    brandfiMarcaId,
    hasAllShopsViewChild1,
    branchFiSucursalId,
  ]);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          {/*           <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpiar
          </Button>*/}
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  // eslint-disable-next-line no-sparse-arrays

  const columns = [
    {
      title: "Tienda",
      dataIndex: "FCNOMBRESUCURSAL",
      key: "FCNOMBRESUCURSAL",
      // sorter: (a, b) =>
      //   parseInt(a.FCNOMBRESUCURSAL) - parseInt(b.FCNOMBRESUCURSAL),
      // ...getColumnSearchProps("FCNOMBRESUCURSAL"),
      // width: "10%",
      ...getColumnSearchProps("FCNOMBRESUCURSAL"),
    },
    {
      title: "CECO",
      dataIndex: "FISUCURSALID",
      key: "FISUCURSALID",
      ...getColumnSearchProps("FISUCURSALID"),
      // width: "5%",
    },
    {
      title: "Marca",
      dataIndex: "FCNOMBREMARCA",
      key: "FCNOMBREMARCA",
      ...getColumnSearchProps("FCNOMBREMARCA"),
      // width: "5%",
    },
    // {
    //   title: "Sucursal",
    //   dataIndex: "FISUCURSALID",
    //   key: "FISUCURSALID",
    //   ...getColumnSearchProps("FISUCURSALID"),
    //   // width: "5%",
    // },
    {
      title: "Total Faltantes",
      key: "FITOTALSUCURSAL",
      render: (item) => {
        return formatCurrency({
          value: item.FITOTALSUCURSAL,
        });
      },
    },
  ];

  const navigateToFuncionOnRouter = () => {
    navigate(`/AdministracionRemitentes`);
  };

  //Expand Table

  const expandColumns = [
    {
      title: "Comentario",
      dataIndex: "FCSEGUIMIENTOANALISTA",
      key: "FCSEGUIMIENTOANALISTA",
      ...getColumnSearchProps("FCSEGUIMIENTOANALISTA"),
    },
    {
      title: "DÃ­a",
      dataIndex: "FDFECHAFALTANTE",
      key: "FDFECHAFALTANTE",
      sorter: (a, b) => new Date(a.FDFECHAFALTANTE) - new Date(b.FDFECHAFALTANTE),
    },
    {
      title: "Semana",
      dataIndex: "FISEMANAFALTANTE",
      key: "FISEMANAFALTANTE",
      sorter: (a, b) => parseInt(a.FISEMANAFALTANTE) - parseInt(b.FISEMANAFALTANTE),
      ...getColumnSearchProps("FISEMANAFALTANTE"),
    },
    {
      title: "Monto",
      render: (item) => formatCurrency({ value: item.FIMONTO }),
    },
    {
      title: "CategorÃ­a",
      key: "FCCATEGORIA",
      dataIndex: "FCCATEGORIA",
      ...getColumnSearchProps("FCCATEGORIA"),
    },
    {
      title: "Estado",
      dataIndex: "FIESTATUSID",
      key: "FIESTATUSID",
      render: (item) => <Tag item={item} />,
      // width: "7%",
      filters: [
        { text: "No aclarado", value: "1" },
        { text: "Pendiente", value: "2" },
        { text: "Rechazado", value: "3" },
        { text: "Aclarado", value: "4" },
        { text: "Incobrables", value: "5" },
        { text: "Seguimiento CxC", value: "6" },
        { text: "Cancelado", value: "7" },
      ],
      onFilter: (value, record) => record.FIESTATUSID === Number(value),
    },
    {
      title: "Evidencias",
      render: (item) => (
        <button
          onClick={() => handleOpenModalEvidencias(item)}
          className={
            true ? `button-styles-detalais-catalogo` : `button-styles-detalais-catalogo-disabled`
          }
          // disabled={item.evidencias.length > 0 ? false : true}
        >
          <EditOutlined style={{ fontSize: 20 }} />
        </button>
      ),
    },
    {
      title: "Acciones",
      key: "operation",
      render: (item) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: getMenuItems(item),
            }}
          >
            <a>
              MÃ¡s <DownOutlined />
            </a>
          </Dropdown>
        </Space>
      ),
    },
  ];

  // const getMissingBySucursalId = async (sucursalId) => {
  //   const axiosInstance = await createAxiosInstanceNew();
  //   const res = await axiosInstance.get(`faltante`, {
  //     params: {
  //       FIPAISID: 1,
  //       FISUCURSALID: sucursalId,
  //     },
  //   });

  //   if (res.status === 200) {
  //     setMissingBySucursalIdData(res.data.body);
  //   }
  // };

  const getMenuItems = (item) => [
    {
      key: "2",
      label: "Actualizar estado",
      onClick: () => {
        handleOpenUpdateStatusModal(item);
      },
      disabled: !hasAllPermissionsChild1 && !hasMissingUpdateStatus,
    },
  ];

  return (
    <>
      <Row justify="center">
        <Col span={22} al>
          <Row justify="space-between" align="middle" className="my-3 ">
            <WeekSelect setShopsData={setShopsData} refetchTrigger={refetchTrigger} />

            <Space direction="horizontal">
              {(hasAllPermissionsChild1 || hasSendersConfigPermission) && (
                <Button
                  onClick={navigateToFuncionOnRouter}
                  // type="submit"
                  className="button-styles-add-element"
                  type="primary"
                >
                  Configurar remitentes
                </Button>
              )}

              {(hasAllPermissionsChild1 || hasMissingUpload) && (
                <Button type="primary" onClick={handleAdd} className="button-styles-add-element">
                  Cargar Faltantes
                </Button>
              )}
            </Space>
          </Row>

          <Table
            dataSource={shopsData}
            rowKey={"FISUCURSALID"}
            columns={columns}
            loading={loading}
            scroll={{ x: 1000, y: 600 }}
            expandable={{
              expandedRowRender: (record) => (
                <Table
                  columns={expandColumns}
                  dataSource={record.faltantes}
                  pagination={false}
                  rowKey={"FCCODIGOFALTANTE"}
                />
              ),
              // defaultExpandedRowKeys: ["0"],
              // onExpand: (expanded, record) => {
              //   getMissingBySucursalId(record.faltantes);
              // },
            }}
          />
        </Col>
      </Row>
      <>
        <UploadCsvStepsProvider>
          <AdministrationFaltantesAddForm
            showModal={showModal}
            setShowModal={setShowModal}
            selectedItem={selectedItem}
            modalKey={modalKey}
            onRefetch={triggerRefetch}
          />
        </UploadCsvStepsProvider>
      </>
      <>
        <EvidenciesView
          faltante={faltante}
          setFaltante={setFaltante}
          onRefetch={triggerRefetch}
          refetchTrigger={refetchTrigger}
        />
      </>

      <>
        <UpdateStatusFaltanteModal
          updateStatusModal={updateStatusModal}
          setUpdateStatusModal={setUpdateStatusModal}
          onRefetch={triggerRefetch}
        />
      </>
    </>
  );
};

